import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, debounceTime, distinctUntilChanged, of, Subject, switchMap } from 'rxjs';
import { ArticleSharingService } from 'src/app/services/article-sharing.service';
import { ArticleService } from 'src/app/services/article.services';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CartService } from 'src/app/services/cart.services';
import { CAtegorieService } from 'src/app/services/categorie.services';
import { ScriptLoaderService } from 'src/app/services/script-loader.services';
import { WishlistService } from 'src/app/services/wishlist.service';

declare var bootstrap: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
   scripts = [
    'assets/js/jquery.min.js',
    'assets/js/bootstrap.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/carousel.js',
    'assets/js/bootstrap-select.min.js',
    'assets/js/lazysize.min.js',
    'assets/js/count-down.js',
    'assets/js/wow.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/multiple-modal.js',
    'assets/js/main.js'
  ];
  cartItems: any[] = [];
  quantity: number = 1;
  article: any;
   currentPage: number = 0;
  wishlistCount: number = 0;
  cartCount: number = 0;
  listCategory:any[]=[];
   subCategories: any[]= [];
articles: any[] = [];
showResults: boolean = false;
searchQuery: string = '';
searchQuerySubject: Subject<string> = new Subject<string>();

selectedCategorie: number | null = null; // si tu veux filtrer par catégorie


  constructor(private cartService :CartService, private router: Router, private scriptLoader: ScriptLoaderService,   private route: ActivatedRoute,private categoriess: CAtegorieService,private articlesService: ArticleService,   private articleSharingService: ArticleSharingService,private authService: AuthServiceService,private wishlist : WishlistService) { }

  ngOnInit(): void {
     this.scriptLoader.loadScripts(this.scripts);
this.getCategory();
    this.loadCartItems();
    this.cartService.cart$.subscribe(cart => {
      this.cartItems = cart;
      this.cartCount = cart.reduce((total, item) => total + item.quantity, 0);
    });

    this.wishlist.wishlist$.subscribe(wishlist => {
      this.wishlistCount = this.wishlist.getWishlistCount();
    });
    this.searchQuerySubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((query) => {
        if (query.trim() === '') {
          this.showResults = false;
          this.articles = [];
          return of([]);
        }

        const requestBody = {
          search: query.trim(),
          id_categorie: this.selectedCategorie ? +this.selectedCategorie : 0
        };

        console.log('🔎 Recherche instantanée avec :', requestBody);

        return this.articlesService.searchArticles(requestBody).pipe(
          catchError((error) => {
            console.error('❌ Erreur recherche :', error);
            return of([]);
          })
        );
      })
    ).subscribe((results: any[]) => {
      this.articles = results;
      this.showResults = this.searchQuery.trim() !== '';
      console.log('✅ Résultats recherche :', this.articles);
    });
  }
  performInstantSearch(): void {
    this.searchQuerySubject.next(this.searchQuery || '');
  }

  loadCartItems(): void {
    this.cartItems = this.cartService.getCartItems();
  }
  goToCart(): void {
    this.closeShoppingCartModal();
    this.router.navigate(['/cart']);
  }

  goToCheckout(): void {
    this.closeShoppingCartModal();
    this.router.navigate(['/checkout']);
  }

  closeShoppingCartModal(): void {
    document.addEventListener('hidden.bs.modal', () => {
      setTimeout(() => {
        const backdrops = document.querySelectorAll('.modal-backdrop');
        const anyOpen = document.querySelector('.modal.show');

        // Supprime les backdrops s'il n'y a plus de modals ouverts
        if (!anyOpen) {
          backdrops.forEach(b => b.remove());
          document.body.classList.remove('modal-open');
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }
      }, 200); // attendre que Bootstrap fasse son animation
    });
  }

  navigateToSubCategory(subCategoryId: number): void {
    this.route.queryParams.subscribe(params => {
      // On récupère la page actuelle depuis les queryParams
      let currentPageFromParams = params['page'] ? Number(params['page']) : 1;

      // Si la marque a changé, on force currentPage à 1
      if (params['subCategoryId'] && Number(params['subCategoryId']) !== subCategoryId) {
        this.currentPage = 1;
      } else {
        this.currentPage = currentPageFromParams;
      }

      console.log("Page actuelle après navigation :", this.currentPage);
    });
    const requestBody = {
      nbre_page: this.currentPage,
      nbre_article: 12,
      order_by: 'id',
      search: '',
      prix_min: 0,
      prix_max: 2000,
      id_categorie: 0,
      id_marque: 0,
      id_sous_categorie: subCategoryId, // ✅ Filtrer par sous-catégorie
      id_sous_sous_categorie: 0
    };

    // ✅ Active le loader
   // this.setFavicon(true);
console.log("jihennn",requestBody)
    this.articlesService.getArticlesByFilters(requestBody).subscribe(
      (response: any) => {
        console.log('Articles récupérés:', response);
        this.articleSharingService.setArticles(response);

        // ✅ Log the subCategories
        console.log('Sous-catégories disponibles:', this.subCategories);

        // ✅ Récupère le libellé et l'envoie directement
        const selectedSubCategory = this.subCategories.find(sub => sub.id === subCategoryId);
        console.log('Sous-catégorie sélectionnée:', selectedSubCategory);

        const subCategoryLabel = selectedSubCategory ? selectedSubCategory.libelle : '';
        console.log('Libellé de la sous-catégorie:', subCategoryLabel);

        // 🚀 Stocker le libellé
        this.articleSharingService.setSelectedCategoryLabel(subCategoryLabel);

       // this.setFavicon(false); // ✅ Désactiver le loader

        // ✅ Rediriger vers la page sous-catégorie



  console.log('Sous-catégorie sélectionnée:', selectedSubCategory);
  console.log('Libellé formaté pour l’URL:', subCategoryLabel);

  // ✅ Rediriger directement vers l'URL de la sous-catégorie
  this.router.navigate(['/subcategorie', subCategoryId, subCategoryLabel.replace(/\s+/g, '-').toLowerCase()]);


      },
      (error) => {
        console.error('Erreur lors de la récupération des articles :', error);
      //  this.setFavicon(false);
      }
    );


  }

  navigateToSearchPage(): void {
    if (this.searchQuery.trim()) {
      this.router.navigate(['/search'], { queryParams: { q: this.searchQuery } });
    }
  }

  goToProduct(articleId: number, libelle: string): void {
    if (!articleId || !libelle) {
      console.error("Erreur : ID ou libellé manquant !");
      return;
    }

    // 👉 Fermer le offcanvas (Bootstrap 5)
    const offcanvasElement = document.getElementById('canvasSearch');
    if (offcanvasElement) {
      const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement) || new bootstrap.Offcanvas(offcanvasElement);
      bsOffcanvas.hide();
    }

    const formattedLibelle = libelle.toLowerCase().replace(/ /g, '-');
    const url = `/singleproduct/${formattedLibelle}/${articleId}`;
    console.log("Navigating to:", url);
    this.router.navigate([url]);
  }

  getRemainingForFreeShipping(): number {
    const threshold = 99;
    const currentTotal = this.getCartTotal();
    return Math.max(0, threshold - currentTotal);
  }
  goToAccount(event: Event): void {
    event.preventDefault(); // évite le rechargement

    if (this.authService.getClientId() !== null) {
      this.router.navigate(['/account']);
    } else {
      this.router.navigate(['/login']);
    }
  }
  getCartTotal(): number {
    const total = this.cartItems.reduce((total, item) => {
      const price = item.promo !== 0 ? item.prix_final : item.prix_ttc;
      const itemTotal = price * item.quantity;
      return total + itemTotal;
    }, 0);
    return total;
  }
  increaseQuantity(article: any): void {
    this.quantity++; // Incrémente directement la valeur
    this.updateTotalPrice(article);
  }

  // Décrémente la quantité (minimum 1)
  decreaseQuantity(article: any): void {
    if (this.quantity > 1) {
      this.quantity--; // Décrémente si > 1
      this.updateTotalPrice(article);
    }
  }

  // Met à jour le prix total
  updateTotalPrice(article: any): void {
    article.totalPrice = this.quantity * article.prix_ttc;
  }
   getCategory(): void {
    this.categoriess.getCategories().subscribe(
      (      response: any[]) => {
        this.listCategory = response;
        console.log('Category list:', this.listCategory);
      },
      (      error: any) => {
        console.error('Could not get category:', error);
      }
    );
  }

  totalItems: number = 0;
  totalPages: number = 0;
  pages: number[] = [];
  navigateToCategory(category: any) {
    const id = Number(category.id);
    const categoryLabel = category.libelle;

    if (isNaN(id)) {
      console.error('❌ ID de catégorie invalide:', category);
      return;
    }

    const requestBody = {
      nbre_page: 1, // On commence sur la première page
      nbre_article: 12,
      order_by: 'id',
      search: '',
      prix_min: 0,
      prix_max: 2000,
      id_categorie: id,
      id_marque: 0,
      id_sous_categorie: 0,
      id_sous_sous_categorie: 0
    };

   // this.setFavicon(true);

    console.log("✅ ID:", id);
    console.log("✅ Libellé:", categoryLabel);

    // Récupérer les articles pour la catégorie
    this.articlesService.getArticlesByFilters(requestBody).subscribe(
      (response: any) => {
        // Stocker les articles et le label de la catégorie
        this.articleSharingService.setArticles(response);
        this.articleSharingService.setSelectedCategoryLabel(categoryLabel);

        // Mise à jour de la pagination
        const totalItems = response[0]?.count || 0;
        const totalPages = Math.ceil(totalItems / 12);

        // Ici, tu peux mettre à jour les variables de pagination du `ShopComponent` (si elles sont partagées)
        this.totalItems = totalItems;
        this.totalPages = totalPages;
        this.pages = Array.from({ length: totalPages }, (_, i) => i + 1); // Générer les pages dynamiquement

        // Naviguer vers la page de la boutique avec l'ID et le libellé de la catégorie
     //   this.setFavicon(false);

        // 🔥 Construire une URL clean
        const urlLabel = categoryLabel.replace(/\s+/g, '-').toLowerCase();
        this.router.navigate(['/shop', id, urlLabel]);
      },
      (error) => {
        console.error('Erreur lors de la récupération des articles :', error);
        //this.setFavicon(false);
      }
    );
  }
}
